import axios from 'axios';
import { apiUrl } from './index';

export default {
  validate({ type, value }) {
    const params = {
      type,
      value,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/validate`,
      params,
    });
  },
};
